import router from "@/router";



export const navigateToQuery = (queryParam, valueQuery) => {

  // console.log('router', router);
  try {
    const route = router.history.current.path;

    router.push({
      path: route.path,
      query: {
        ...route.query,
        [queryParam]: valueQuery,
      },
    });
  } catch (error) {
    console.error("Error en la navegación:", error);
  }
}




export const removeQuery = (query) => {

  try{
    const route = router.history.current.path;
    
    const updatedQuery = { ...route.query };
    delete updatedQuery[query];
    router.push({ path: route.path, query: updatedQuery });
  }catch(error){
    console.error("Error en la navegacion:", error )
  }
}